import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";
import GridOverlay1 from "./sub-comps/gridCells/GridOverlay1";
import GridOverlay2 from "./sub-comps/gridCells/GridOverlay2";
import GridOverlay3 from "./sub-comps/gridCells/GridOverlay3";
import GridOverlay4 from "./sub-comps/gridCells/GridOverlay4";
import YouTubeEmbed from "./sub-comps/YoutubeEmbed";

function WhyUs() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  const easing = [0.42, 0, 0.58, 1]; // Ease in-out curve

  const containerVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 1, ease: easing, staggerChildren: 0.3 },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: { duration: 0.5, ease: easing },
    },
  };

  return (
    <div
      ref={ref}
      className="flex flex-col lg:flex-row w-full py-16 px-6 md:px-12 lg:px-16"
    >
      {/* Text Section */}
      <motion.div
        className="w-full lg:w-2/5 mb-8 lg:mb-0"
        initial="hidden"
        animate={isInView ? "visible" : "hidden"}
        variants={containerVariants}
      >
        <motion.p
          className="lg:text-5xl lg:mb-4 text-3xl mb-4 font-extralight text-customAqua600 max-w-[500px]"
          variants={itemVariants}
        >
          Pourquoi choisir notre centre dentaire ?
        </motion.p>
        <motion.p
          className="lg:text-sm text-sm mb-4 leading-6"
          variants={itemVariants}
        >
          Découvrez pourquoi nos services dentaires se distinguent des autres.
          De notre équipe expérimentée à notre équipement de pointe, nous
          fournissons des soins exceptionnels pour tous vos besoins dentaires.
        </motion.p>

      </motion.div>

      {/* Grid Section */}
      <motion.div
        className="w-full lg:w-3/5 flex justify-center"
        initial="hidden"
        animate={isInView ? "visible" : "hidden"}
        variants={containerVariants}
      >
        <motion.div
          className="w-fit grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 grid-rows-2 gap-1"
          variants={containerVariants}
        >
          <motion.div variants={itemVariants}>
            <GridOverlay1 />
          </motion.div>
          <motion.div variants={itemVariants}>
            <GridOverlay2 />
          </motion.div>
          <motion.div variants={itemVariants}>
            <GridOverlay3 />
          </motion.div>
          <motion.div variants={itemVariants}>
            <GridOverlay4 />
          </motion.div>
        </motion.div>
      </motion.div>
    </div>
  );
}

export default WhyUs;
